// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import myw from 'myWorld-base';
import 'myWorld/uiComponents/dialog';

myw.ManageBookmarksDialog = myw.Dialog.extend({
    id: 'bookmark-list-accordion',
    tagName: 'ul',
    className: 'list',

    options: {
        modal: true,
        autoOpen: false,
        minWidth: 490,
        position: { my: 'center', at: 'top+150', of: window },
        title: '{:manage_title}',
        buttons: {
            Close: {
                text: '{:close_btn}',
                class: 'right',
                click() {
                    this.close();
                }
            },
            Back: {
                text: '{:back_btn}',
                click() {
                    this.close();
                    this.owner.showCreateDialog();
                }
            }
        }
    },

    initialize(options) {
        this.owner = options.owner;
        this.app = this.owner.app;
        this.system = this.app.system;
        this.bookmarkViews = [];

        myw.Dialog.prototype.initialize.call(this, options);
    },

    render() {
        myw.Dialog.prototype.render.apply(this);
        myw.softKeyboardInput.enableOn(this.$el, this.app);
    },
    /*
     * Shows the bookmark window.
     */
    show() {
        this.populateBookmarkList();
        this.open();
    },

    /*
     * Populates the list of bookmarks accessible to the user
     */
    populateBookmarkList() {
        this.list = this.$el;
        this.list.empty();

        this.system.getBookmarksForUser().then(bookmarks => {
            this.list.empty();
            if (bookmarks.length === 0) {
                this.populateWithEmptyMsg();
            } else {
                //Sort the bookmarks list alphabetically and assign it to this.bookmarks
                this.bookmarks = this.owner.bookmarks = _.sortBy(bookmarks, bookmark =>
                    bookmark.title.toLowerCase()
                );

                _.each(this.bookmarks, bm => this.addBookmarkToList(bm));
            }
        });
        this.delegateEvents();
    },

    /*
     * Adds a message to the dialog indicating that there are no saved bookmarks.
     */
    populateWithEmptyMsg() {
        this.list.html(this.msg('no_saved'));
    },

    addBookmarkToList(bookmark) {
        const bookmarkView = new myw.ManageBookmarkView(this, {
            details: bookmark,
            showBookmarkDetail: this.options.showBookmarkDetail
        });
        this.bookmarkViews.push(bookmarkView);
        this.list.append(bookmarkView.el);
    }
});

export default myw.ManageBookmarksDialog;
